// Notifications page
import React from 'react';
import ReactDOM from 'react-dom';
import { createStore, bindActionCreators, applyMiddleware } from 'redux';
import { connect, Provider } from 'react-redux';
import thunk from 'redux-thunk';
import NotificationsReducers from './reducers/notifications.reducers';
import * as NotificationsActions from './actions/notifications.actions';
import NotificationIcon from './components/notification-icon';
import ErrorBoundary from '../components/error-boundary';

const notificationsMapsStateToProps = (state) => ({
  notificationsData: state.data || [],
  isLoading: state.isLoading || false
});

const notificationsMapsDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(NotificationsActions, dispatch),
});

const NotificationsAppComp = connect(
  notificationsMapsStateToProps,
  notificationsMapsDispatchToProps,
)(NotificationIcon);
let notificationsStore;

const initNotificationsComp = (data = []) => {
  notificationsStore = createStore(
    NotificationsReducers,
    { data, isLoading: true },
    applyMiddleware(thunk)
  );
  const mountId = document.getElementById('notification-react-div');
  if (mountId) {
    ReactDOM.render(
      <Provider store={notificationsStore}>
        <ErrorBoundary>
          <NotificationsAppComp />
        </ErrorBoundary>
      </Provider>,
      mountId,
    );
  }
};

const notificationModel = {
  reloadData: () => {
    console.log('reload data');
    if (typeof notificationsStore !== 'undefined') {
      NotificationsActions.NotificationsLoadData();
    }
  },
};

window.notificationModel = Object.create(notificationModel);
window.initNotificationsComp = initNotificationsComp;
